import script from "./ParticipantDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantDetail.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantDetail.vue?vue&type=style&index=0&id=79a7dd5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a7dd5e"]])

export default __exports__